import React from 'react';
import List from '../cruds/List';
import Iterate from '../components/container/Iterate';
import {OutputAttachmentRow} from '../components/output/OutputAttachments';
import Table, {Column} from '../components/container/Table';
import OutputValue from '../components/output/OutputValue';
import {Route, Switch} from 'react-router-dom';
import {booleanFormatter} from '../functions/textFormatter';

const ENTITY_NAME = 'acknowlegmentSDS/history';
const ENTITY_RUOTE = 'acknowlegmentSDS/history';
const TITLE = 'header.acknowlegmentSDSHistory';

const filtersValidation = (filters, name) => {
    const {from, to} = filters;
    if (name === 'from' && from && to && from.isAfter(to)) {
        filters.to = from;
    }

    if (name === 'to' && from && to && to.isBefore(from)) {
        filters.from = to;
    }
};

const CrudList = props => {
    const user = JSON.parse(localStorage.loggedUser);
    const filters = [
        {name: 'from', placeholder: 'logs.from', type: 'date'},
        {name: 'to', placeholder: 'logs.to', type: 'date'},
        {name: 'fullSearch', placeholder: 'logs.description'},
    ];

    const table = <Table>
        <Column label="general.department" orderingName="DEPARTMENT_NAME"><OutputValue name="departmentName"/></Column>
        <Column label="general.activity"><OutputValue name="activityName"/></Column>
        <Column label="general.substance" orderingName="SUBSTANCE_CODE"><OutputValue name="substanceCode"/></Column>
        <Column label="substances.sds" orderingName="SDS_ATTACHMENTS">
            <Iterate on="savedSDS.attachments">
                <OutputAttachmentRow/>
            </Iterate>
        </Column>
        <Column label="acknowlegmentSDS.acknowledger" orderingName="ACKNOWLEDGER"><OutputValue
            name="acknowledger"/></Column>
        <Column label="acknowlegmentSDS.acknowledgedTimestamp" orderingName="TIMESTAMP"><OutputValue
            name="acknowledgedTimestamp"/></Column>
        <Column label="acknowlegmentSDS.acknowledged" orderingName="ACKNOWLEDGED"><OutputValue name="acknowledged"
                                                                                               formatter={booleanFormatter}/></Column>
    </Table>;

    return (
        <List title={TITLE}
              entityName={ENTITY_NAME}
              entityRoute={ENTITY_RUOTE}
              component={table}
              filters={filters}
              filtersValidation={filtersValidation}
              defaultOrdering="TIMESTAMP"
              defaultAsc={false}
              hideAddButton={true}
        />
    );
};

const AcknowlegmentSDSHistory = props => {
    const basePath = props.match.url;
    return (
        <Switch>
            <Route exact path={basePath} component={CrudList}/>
        </Switch>
    );
};

export default AcknowlegmentSDSHistory;



// WEBPACK FOOTER //
// ./src/main/pages/AcknowlegmentSDSHistory.js